import { Link } from "react-router-dom";
import { Plus, ImageOff } from "lucide-react";
import { toast } from "sonner";
import { ProductBadges } from "./Badges";
import { imgUrl } from "@/lib/api";
import { euro } from "@/lib/shop";
import { useCart } from "@/context/CartContext";

import { HeartButton } from "./HeartButton";
import { TikTokShopButton } from "./TikTokShopButton";
import { useShopSettings } from "@/context/ShopSettingsContext";

export const ProductCard = ({ p, index = 0 }) => {
  const { add } = useCart();
  const { showcase_mode } = useShopSettings();
  return (
    <div
      data-testid={`product-card-${p.id}`}
      className={`rise group flex flex-col overflow-hidden rounded-2xl bg-white transition-transform duration-200 hover:-translate-y-1 ${index % 2 ? "neon-purple" : "neon-yellow"}`}
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
    >
      <Link to={`/prodotto/${p.id}`} data-testid={`product-link-${p.id}`} className="relative block aspect-square bg-white">
        {p.images?.[0] ? (
          <img src={imgUrl(p.images[0])} alt={p.name} loading="lazy" className="h-full w-full object-contain p-2" />
        ) : (
          <div className="grid h-full w-full place-items-center bg-muted text-muted-foreground"><ImageOff className="h-8 w-8" /></div>
        )}
      </Link>
      <div className="flex flex-1 flex-col gap-2 border-t border-border p-3">
        <ProductBadges p={p} compact />
        <Link to={`/prodotto/${p.id}`} className="line-clamp-2 text-sm font-bold leading-snug sm:text-[15px]">{p.name}</Link>
        {showcase_mode ? (
          <div className="mt-auto flex items-center gap-1.5 pt-1">
            <TikTokShopButton product={p} size="sm" label="TikTok Shop" className="min-w-0 flex-1" testId={`product-tiktok-button-${p.id}`} placement="catalog_card" />
            <HeartButton id={p.id} className="h-9 w-9 shrink-0" />
          </div>
        ) : (
        <div className="mt-auto flex items-center justify-between gap-2 pt-1">
          <span data-testid={`product-price-${p.id}`} className="font-display text-lg font-extrabold">{euro(p.price)}</span>
          <div className="flex items-center gap-1.5">
          <HeartButton id={p.id} className="h-9 w-9" />
          <button
            data-testid={`add-to-cart-button-${p.id}`}
            aria-label="Aggiungi al carrello"
            className="btn-mc !h-9 !w-9 !p-0"
            onClick={() => { add(p); toast.success("Aggiunto al carrello"); }}
          >
            <Plus className="h-5 w-5" />
          </button>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};
